export type PdfExportJobStatus = 'PENDING' | 'RUNNING' | 'READY' | 'FAILED';

export type PdfExportSource = 'DOWNLOAD' | 'EMAIL' | 'SCHEDULED';

export interface PdfExportJob {
	accountId?: string | null;
	completedAt?: string | null;
	createdAt?: string | null;
	downloadUrl?: string | null;
	downloadUrlExpiresAt?: string | null;
	errorMessage?: string | null;
	jobId: string;
	source?: PdfExportSource | null;
	status: PdfExportJobStatus;
	viewId?: string | null;
}

export interface PdfExportWebSocketEvent {
	messageType: 'pdfExport';
	jobId: string;
	status: PdfExportJobStatus;
	downloadUrl?: string | null;
	errorMessage?: string | null;
}

export const PDF_EXPORT_TIMEOUT_MS = 90_000;

export const PDF_EXPORT_GENERIC_ERROR = 'PDF export failed. Try again.';

export const PDF_EXPORT_TIMEOUT_ERROR = 'PDF export timed out. Try again.';
